class ProductTabs {
  constructor(root) {
    this.root = root;
    this.titles = Array.from(root.querySelectorAll('.item.title[data-tab-id]'));
    this.panels = Array.from(root.querySelectorAll('.item.content[data-content-id]'));
    this.mqlMobile = window.matchMedia('(max-width: 767px)');

    if (!this.titles.length || !this.panels.length) return;

    this.onClick = this.onClick.bind(this);
    this.root.addEventListener('click', this.onClick);

    if (this.mqlMobile.matches) {
      this.closeAll({ focus: false });
    } else {
      const active = this.titles.find((t) => t.classList.contains('active')) || this.titles[0];
      this.setActive(active?.dataset?.tabId, { focus: false });
    }

    this.mqlMobile.addEventListener('change', (e) => {
      if (e.matches) {
        this.closeAll({ focus: false });
      } else {
        const active = this.titles.find((t) => t.classList.contains('active')) || this.titles[0];
        this.setActive(active?.dataset?.tabId, { focus: false });
      }
    });
  }

  getPanel(tabId) {
    return this.panels.find((p) => p.dataset.contentId === tabId) || null;
  }

  updateSwiperPagination(swiperRootEl, swiperInstance) {
    if (!swiperRootEl) return;
    const colorarr = ['blue', 'purple', 'green', 'red', 'orange', 'yellow'];
    const bullets = Array.from(
      swiperRootEl.querySelectorAll('.swiper-pagination .swiper-pagination-bullet')
    );
    if (!bullets.length) return;

    const activeIndex =
      typeof swiperInstance?.realIndex === 'number'
        ? swiperInstance.realIndex
        : typeof swiperInstance?.activeIndex === 'number'
          ? swiperInstance.activeIndex
          : 0;

    bullets.forEach((bulletEl, i) => {
      colorarr.forEach((c) => bulletEl.classList.remove(`swiper-${c}`));
      bulletEl.classList.add(`swiper-${colorarr[i % colorarr.length]}`);
      bulletEl.classList.toggle('process', i <= activeIndex);
    });
  }

  initSwipers(container) {
    if (!container) return;
    const swiperEls = Array.from(container.querySelectorAll('[data-techspecs-swiper]'));
    if (!swiperEls.length) return;

    swiperEls.forEach((el) => {
      const swiperCtor = window.Swiper;
      if (!swiperCtor) return;

      if (el.__swiperInstance) {
        el.__swiperInstance.update();
        requestAnimationFrame(() => this.updateSwiperPagination(el, el.__swiperInstance));
        return;
      }

      const slidesDesktop = parseInt(el.dataset.slidesDesktop || '2', 10);
      const slidesMobile = parseInt(el.dataset.slidesMobile || '1', 10);
      const autoplay = el.dataset.autoplay === 'true';
      const autoplayDelay = parseInt(el.dataset.autoplayDelay || '3000', 10);
      const loop = el.dataset.loop === 'true';

      el.__swiperInstance = new swiperCtor(el, {
        slidesPerView: slidesMobile,
        spaceBetween: 30,
        loop,
        autoplay: autoplay
          ? {
              delay: autoplayDelay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }
          : false,
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev')
        },
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true
        },
        on: {
          init: (swiper) => {
            requestAnimationFrame(() => this.updateSwiperPagination(el, swiper));
          },
          paginationUpdate: (swiper) => {
            requestAnimationFrame(() => this.updateSwiperPagination(el, swiper));
          },
          update: (swiper) => {
            requestAnimationFrame(() => this.updateSwiperPagination(el, swiper));
          },
          slideChangeTransitionStart: (swiper) => {
            requestAnimationFrame(() => this.updateSwiperPagination(el, swiper));
          }
        },
        breakpoints: {
          768: {
            slidesPerView: slidesDesktop
          }
        }
      });
    });
  }

  setActive(tabId, { focus } = { focus: true }) {
    if (!tabId) return;

    this.titles.forEach((titleEl) => {
      const isActive = titleEl.dataset.tabId === tabId;
      titleEl.classList.toggle('active', isActive);
      const button = titleEl.querySelector('.switch');
      if (button) button.setAttribute('aria-expanded', String(isActive));
      if (isActive && focus && button) button.focus({ preventScroll: true });
    });

    this.panels.forEach((panelEl) => {
      const isActive = panelEl.dataset.contentId === tabId;
      if (isActive) {
        panelEl.removeAttribute('hidden');
      } else {
        panelEl.setAttribute('hidden', '');
      }
    });

    const activePanel = this.getPanel(tabId);
    this.initSwipers(activePanel);
  }

  closeAll({ focus } = { focus: false }) {
    this.titles.forEach((titleEl) => {
      titleEl.classList.remove('active');
      const button = titleEl.querySelector('.switch');
      if (button) button.setAttribute('aria-expanded', 'false');
      if (focus && button) button.blur();
    });

    this.panels.forEach((panelEl) => {
      panelEl.setAttribute('hidden', '');
    });
  }

  onClick(event) {
    const button = event.target.closest('.item.title .switch');
    if (!button) return;

    const title = button.closest('.item.title[data-tab-id]');
    if (!title) return;

    event.preventDefault();
    const clickedId = title.dataset.tabId;
    const isActive = title.classList.contains('active');

    if (this.mqlMobile.matches && isActive) {
      this.closeAll({ focus: false });
      return;
    }

    this.setActive(clickedId, { focus: false });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-tabs]').forEach((root) => new ProductTabs(root));
});

